import React, { useEffect, useState } from 'react';
import { ComboBox, IComboBoxOption, Label } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../system/TimeTaxSupportSystemClient';
import { Company } from '../../system/company/Company';
import { DateTime } from 'luxon';

export interface OptionEmpresa {
  key: string;
  text: string;
}

interface EmpresaDropdownProps {
  system: TimeTaxSupportSystemClient;
  label?: string;
  defaultValue?: string;
  disabled?: boolean;
  className?: string;
  paisId?: string | null;
  onChangeSelected: (selected: OptionEmpresa | null) => void;
  period: DateTime | undefined;
}

const EmpresaDropdown: React.FC<EmpresaDropdownProps> = ({
  system,
  label,
  paisId,
  defaultValue,
  disabled = false,
  period,
  className,
  onChangeSelected,
}) => {
  const [options, setOptions] = useState<IComboBoxOption[]>([]);
  const [selectedKey, setSelectedKey] = useState<string>(defaultValue ?? '');

  useEffect(() => {
    const loadCompanies = async () => {
      if (!period) return;
      try {
        const periodFormat = period.toFormat('yyyy-MM-dd'); // formateee 2026-07-01
        const companies : Company[] = await system.getCompanySystem().getListComapniesActives(periodFormat);
        const filtered = paisId ? companies.filter((c) => c.getPaisid() === paisId) : companies;
        onChangeSelected(null)
        setSelectedKey('');
        setOptions(
          filtered.map((c) => ({
            key: c.getId(),
            text: c.getName(),
          })),
        );
      } catch (error) {
        console.error('Error loading companies:', error);
      }
    };

    loadCompanies();
  }, [system, paisId, period]);

  useEffect(() => {
    if (!paisId) return;

    if (selectedKey) {
      const stillValid = options.some((o) => o.key === selectedKey);
      if (!stillValid) {
        setSelectedKey('');
        onChangeSelected(null);
      }
    }
  }, [paisId, options, period]);

  useEffect(() => {
    if (defaultValue !== undefined) {
      setSelectedKey(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className={className}>
      {label && <Label>{label}</Label>}

      <ComboBox
        options={options}
        selectedKey={selectedKey}
        disabled={disabled}
        autoComplete="on"
        allowFreeform={false}
        useComboBoxAsMenuWidth
        onChange={(_, option) => {
          const value = option
            ? {
                key: String(option.key),
                text: option.text,
              }
            : null;

          setSelectedKey(String(option?.key ?? ''));
          onChangeSelected(value);
        }}
      />
    </div>
  );
};

export default EmpresaDropdown;
